import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  IncidentStoreActions,
  IncidentStoreSelectors,
  IncidentStoreReducer,
} from './index';
import {
    IncidentDto,

} from '@cradua/data';

@Injectable()
export class IncidentFacade {
  constructor(
    private store: Store<
    IncidentStoreReducer.IncidentPartialState
    >
  ) {}

  incident$ = this.store.select(
    IncidentStoreSelectors.getLastInsertedValue
  );
  incidentError$ = this.store.select(
    IncidentStoreSelectors.getIncidentError
  );
  searchedIncidentRecord$ = this.store.select(
    IncidentStoreSelectors.getSearchIncidentRecord
  );
  findIncidentRecord$ = this.store.select(
    IncidentStoreSelectors.getSearchIncidentIdRecord
  );
  loadRegister$ = this.store.select(
    IncidentStoreSelectors.getAllIncident
  );

  getselected() {
    return this.store.select(IncidentStoreSelectors.getSelected);
  }

   isLoadingIncident(query) {
    this.store.dispatch(
        IncidentStoreActions.fetchIncidentRecord({fetch: query})
    );
    return this.store.select(
        IncidentStoreSelectors.loadingIncident
    );
  }

  isLoadingIncidentById(id: string) {
    this.store.dispatch(
      IncidentStoreActions.fetchByIdIncidentRecord({ id }),
    );
    return this.store.select(IncidentStoreSelectors.loadingIncident);
  }

  get loadIncident() {
    // this.store.dispatch(
    //     IncidentStoreActions.loadIncident()
    // );
    return this.store.select(
        IncidentStoreSelectors.getAllIncident
    );
  }

  get clearIncident() {
    this.store.dispatch(IncidentStoreActions.clearIncident());
    return this.store.select(IncidentStoreSelectors.getAllIncident);
  }

  fetchIncidentRecord(query) {
    this.store.dispatch(
      IncidentStoreActions.fetchIncidentRecord({ fetch: query }),
    );
  }

  fetchByIdIncidentRecord(id: string) {
    this.store.dispatch(
      IncidentStoreActions.fetchByIdIncidentRecord({ id }),
    );
  }

  searchIncidentRecord(query) {
    this.store.dispatch(
        IncidentStoreActions.searchIncidentRecord({
        query,
      })
    );
  }

  findIncidentRecord(query) {
    this.store.dispatch(
        IncidentStoreActions.searchIncidentIdRecord({
        query,
      })
    );
  }

  addIncident(
    newIncident: IncidentDto
  ) {
    this.store.dispatch(
      IncidentStoreActions.addIncident({
        newIncident
      })
    );
    return this.store.select(IncidentStoreSelectors.loadingIncident);
  }

  updateIncident(
    updateIncident: IncidentDto
  ) {
    this.store.dispatch(
        IncidentStoreActions.updateIncident({
        updateIncident,
      })
    );
    return this.store.select(IncidentStoreSelectors.loadingIncident);
  }



  removeIncident(id: string) {
    this.store.dispatch(
        IncidentStoreActions.removeIncident({ id })
    );
  }

}
